import Header from "./Components/header";
import { Sidebar } from "./Components/sidebar";
import React from "react";
import { Router } from "./Router";
import { useSelector } from "react-redux";
import { decryptData, getItem, Storage } from "./Services/Storage";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import { Axios } from "./Services/Axios";
import { CenterSettings } from "./Components/Settings/CenterSettings";
import { ToastContainer } from "react-toastify";
function App() {
  const auth = decryptData(useSelector((e) => e.LoggedIn));
  const { username, role } = Storage.getItem("user") || {};
  React.useEffect(() => {
    if (auth) {
      const token = getItem("token");
      Axios.interceptors.request.use(
        async (config) => {
          config.headers = {
            ...config.headers,
            Authorization: `Bearer ${token}`,
          };
          return config;
        },
        (err) => Promise.reject(err)
      );
    }
  }, [auth]);
  // React.useEffect(() => {
  //   console.log(role, "l");
  // }, [role]);
  return (
    <section className="dashboardLayout w-full h-full flex">
      {auth ? (
        <>
          <Header />
          <Sidebar />
        </>
      ) : (
        <></>
      )}
      <div className="mainContainer">
        {auth && (
          <div className="bg-white border-b border-gray-100 shadow-sm flex justify-end p-3 px-6 sticky top-0 z-20">
            <div className="flex flex-col justify-center mr-3">
              <span className="text-gray-800 block text-sm font-bold text-right">
                {username || "User"}
              </span>
              <p className="text-gray-500 text-right text-xs capitalize font-medium">{role || "Role"}</p>
            </div>
            <div className="flex items-center">
              <div className="h-10 w-10 rounded-full bg-gradient-to-br from-[#E52C31] to-[#FCC90D] flex items-center justify-center text-white shadow-sm border-2 border-white ring-2 ring-gray-50">
                <span className="text-sm font-bold uppercase">{username ? username.substring(0, 2) : "U"}</span>
              </div>
            </div>
          </div>
        )}
        <Router />
        {role?.role === "center" ? <CenterSettings /> : <></>}
      </div>
      <ToastContainer
        position="bottom-right"
        theme="colored"
        autoClose={3000}
      />
    </section>
  );
}

export default App;
